"use client";

import Link, { LinkProps } from "next/link";
import { FC, Suspense, useState } from "react";
import { WithChildren } from "apps/website/types";
import { normaliseHref } from "apps/website/utils/links/href";

import { QuerySetter } from "./QuerySetter";

export const LinkWithQuery: FC<LinkProps & WithChildren> = (props) => {
  const normalisedHref = normaliseHref(props.href as string);
  const [ href, setHref ] = useState<string>(normalisedHref);

  return (
    <>
      <Link {...props} href={href} />
      <Suspense>
        <QuerySetter href={normalisedHref} onUpdateHref={(newHref) => setHref(newHref)} />
      </Suspense>
    </>
  );
};
